import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { getClientProfileEntryDetailsPending, getClientProfileEntryDetailsFulfilled, getClientProfileEntryDetailsRejected } from '../actions';
import {
  sendApiRequest, notifyWarning, notifyError,
} from '../../../actions';
import { CLIENT_PROFILE_DETAILS_ENTRY } from '../constants/clientProfileEntryDetailsMessages';
import { GET_CLIENT_PROFILE_ENTRY_DETAILS } from '../types';

const createPayload = payload => ({
  method: 'get',
  url: 'Client/Details',
  onSuccess: [getClientProfileEntryDetailsFulfilled,
    response => (!response.data ? notifyWarning(CLIENT_PROFILE_DETAILS_ENTRY.NOT_FOUND) : { type: '' })],
  onError: [
    getClientProfileEntryDetailsRejected,
    // TO DO: display error messages received from the server.
    () => notifyError(CLIENT_PROFILE_DETAILS_ENTRY.NOT_FOUND),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getClientProfileEntryDetailsEpic$ = action$ => action$.pipe(
  ofType(GET_CLIENT_PROFILE_ENTRY_DETAILS.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(getClientProfileEntryDetailsPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getClientProfileEntryDetailsEpic$;


// WEBPACK FOOTER //
// ./src/features/client-profile/epics/getClientProfileEntryDetailsEpic.js